import { HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';

export abstract class HttpParameterCodecExtended extends HttpUrlEncodingCodec {

  abstract valueToString(value: unknown): string;
  abstract valueFromString(stringValue: string): unknown;

}

/**
 * Provides encoding and decoding of URL parameter and query-string values.
 *
 * Serializes and parses URL parameter keys and values to encode and decode them.
 * If you pass URL query parameters without encoding,
 * the query parameters can be misinterpreted at the receiving end.
 *
 *
 * @publicApi
 */
@Injectable()
export class CorrectedHttpUrlEncodingCodec extends HttpParameterCodecExtended {
  valueToString(value: any): string {

    if (typeof value === "string" || value === undefined || value === null)
      return value;

    if (typeof value.toJSON === 'function')
      return value.toJSON();

    return JSON.stringify(value);
  }

  valueFromString(stringValue: string): unknown {
    if (typeof stringValue !== "string" || stringValue === undefined || stringValue === null)
      return stringValue;

    return JSON.parse(stringValue);
  }
}
